import type { ReactNode } from "react";
import { RequestOriginsStatus } from "../../../utils/models";
import { RequestOriginFilterSkeleton } from "./RequestOriginFilterSkeleton";
import type { OriginFilterControl, OriginFilterState } from "./requestOriginMeta";

/**
 * What a filter surface shows for the Origin filter: its own control once origins are in, the shared skeleton while they
 * load, nothing where they are unavailable or failed (the failed notice sits above the list instead).
 */
export const originFilterNode = (state: OriginFilterState, ready: (control: OriginFilterControl) => ReactNode): ReactNode => {
	switch (state.status) {
		case RequestOriginsStatus.Ready:
			return ready(state.control);
		case RequestOriginsStatus.Loading:
			return <RequestOriginFilterSkeleton />;
		case RequestOriginsStatus.Unavailable:
		case RequestOriginsStatus.Failed:
			return null;
		default: {
			const unhandled: never = state;
			throw new Error(`Unhandled origin filter state ${JSON.stringify(unhandled)}`);
		}
	}
};
